import { configureStore } from '@reduxjs/toolkit'

import { internetSlice } from './slices/internet'
import { recordSlice } from './slices/record'
import { pipSlice } from './slices/pip'
import { popupSlice } from './slices/popupText'
import { chatSlice } from './slices/chat'
import { mediaDevicesSlice } from './slices/mediaDevices'
import { roomSlice } from './slices/room'
import { meetDataSlice } from './slices/meetData'
import { typeOfMeetSlice } from './slices/typeOfMeet'
import { mediaPermissionsSlice } from './slices/permissions'
import { windowSlice } from './slices/window'
import { reactionsSlice } from './slices/reactions'
import { tokenSlice } from './slices/token'
import { mediaSlice } from './slices/media'

export const store = configureStore({
  reducer: {
    [roomSlice.name]: roomSlice.reducer,
    [internetSlice.name]: internetSlice.reducer,
    [recordSlice.name]: recordSlice.reducer,
    [pipSlice.name]: pipSlice.reducer,
    [popupSlice.name]: popupSlice.reducer,
    [chatSlice.name]: chatSlice.reducer,
    [mediaDevicesSlice.name]: mediaDevicesSlice.reducer,
    [meetDataSlice.name]: meetDataSlice.reducer,
    [typeOfMeetSlice.name]: typeOfMeetSlice.reducer,
    [mediaPermissionsSlice.name]: mediaPermissionsSlice.reducer,
    [windowSlice.name]: windowSlice.reducer,
    [reactionsSlice.name]: reactionsSlice.reducer,
    [tokenSlice.name]: tokenSlice.reducer,
    [mediaSlice.name]: mediaSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
